import React, { FC, useMemo } from 'react'

import { ConditionRender } from 'components'
import { TagsForm } from '..'

import { LocalTagsProps } from './LocalTags.props'

const LocalTags: FC<LocalTagsProps> = ({ tags, onCreateTag, onUpdateTag, isLocalEditable, setShowAlert }) => {
  const maxOrder = useMemo(() => tags.reduce((acc, el) => (el.order_number > acc ? el.order_number : acc), 0), [tags])

  return (
    <form className="label-form">
      <ConditionRender
        condition={!!isLocalEditable}
        component={
          <TagsForm
            tags={tags}
            onCreateTag={onCreateTag}
            onUpdateTag={onUpdateTag}
            maxOrder={maxOrder}
            setShowAlert={setShowAlert}
          />
        }
      />
    </form>
  )
}

export default LocalTags
